export enum StreamType {
  WITH_OFFSET = 'WITH_OFFSET',
  WITH_CURSOR = 'WITH_CURSOR',
}
